(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-set"] && !Shopify.designMode) return;
  try {
    class ProductSet extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.product-set__button');
      this.error = this.querySelector('.product-set__error');
      if (this.button) this.button.addEventListener('click', () => this.addAll());
    }

    async addAll() {
      const ids = (this.dataset.variantIds || '').split(',').filter(Boolean);
      if (ids.length === 0 || this.button.getAttribute('aria-busy') === 'true') return;
      const theme = window.themeVariables || {};
      const routes = theme.routes || {};
      const cartUrl = routes.cartUrl || '/cart';
      this.button.setAttribute('aria-busy', 'true');
      this.error.hidden = true;
      try {
        const added = await fetch((routes.cartAddUrl || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })), sections: 'mini-cart' }),
        });
        const addedJson = await added.json();
        if (!added.ok) throw new Error(addedJson.description || addedJson.message || '');
        const cart = await (await fetch(cartUrl + '.js')).json();
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
        cart.sections = addedJson.sections;
        const drawer = theme.settings && theme.settings.cartType === 'drawer';
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart, openMiniCart: drawer } }));
        if (!drawer) window.location.href = cartUrl;
      } catch (error) {
        this.error.textContent = error.message || 'Lisäys ostoskoriin ei onnistunut. Yritä uudelleen.';
        this.error.hidden = false;
      } finally {
        this.button.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('product-set')) customElements.define('product-set', ProductSet);
  } catch(e) { console.error(e); }
})();

})();
